<template>
    <div class="action-item" @click="$store.state.core.featuresStatus.disable_animation = !$store.state.core.featuresStatus.disable_animation " :class="{active: $store.state.core.featuresStatus.disable_animation }">
        <div class="active-action item" v-if="$store.state.core.featuresStatus.disable_animation ">
          <span class="icon-check"></span>
        </div>



        <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                >
                    <div v-html="icons.stopAnimation"></div>
                    <h3>{{$t('stop animation')}}</h3>
                </div>
            </template>
            <span>{{$t('Stop website animations')}}</span>
        </v-tooltip>

        <v-style v-if="$store.state.core.featuresStatus.disable_animation ">
            *:not(.rd-mobilemenu_ul) {
            /*CSS transitions*/
            -o-transition-property: none !important;
            -moz-transition-property: none !important;
            -ms-transition-property: none !important;
            -webkit-transition-property: none !important;
            transition-property: none !important;
            /*CSS transforms*/
            -o-transform: none !important;
            -moz-transform: none !important;
            -ms-transform: none !important;
            -webkit-transform: none !important;
            transform: none !important;
            /*CSS animations*/
            -webkit-animation: none !important;
            -moz-animation: none !important;
            -o-animation: none !important;
            -ms-animation: none !important;
            animation: none !important;
            }
        </v-style>
    </div>
</template>


<script>
    import {icons} from '../../utils/icons'
    export default {
        name: "disable-js",
        data() {
            return {
                active: false,
                icons
            }
        },
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            }
        },
        mounted() {
            document.addEventListener("mousemove", ()=> {

            })
        },
        watch: {
            '$store.state.core.featuresStatus.disable_animation': function (state) {
              localStorage.setItem('featuresStatus', JSON.stringify(this.$store.state.core.featuresStatus))
                if (state) {
                    if (event.stopPropagation) {
                        event.stopPropagation ();
                        this.$emit('countAnalytics', this.data._id)
                    }
                    event.cancelBubble = true;
                }
            }
        }
    }
</script>

<style scoped>

</style>
